/**
 * Screen rendering functions
 */

import { logger, dId, dQS, dQSa, setHform, showError } from "./utils";
import { hide_loader, show_loader } from "./loader_ticker";
import { reservaD, reservaT, provs, provCt, page_id, vehiculoAry, json_response } from "./variables";
import { langDict } from "./dict";
import { google_send_detail, google_send_search } from "./google";


import { redrawDivs } from "./result_render";

import { ajax_list_detail, ajax_list_results } from "./ajax";
import { sortResults, showResults, checkZeroes } from "./result_list";
import { step1CardListener } from "./toggle_card";
import { showDetail } from "./result_detail";
import { guardarmireserva_build } from "./save_search";

declare const LANG: string;
declare const GCLID: string;

let detail_request = false;
let results_returned = 0;
let noResCt = 0;

/**
* Step 1: Request.
* Allow for one last call when all results are in to generate "mixed" results
* Where external availability is mixed with internal prices. 
**/
function call_results(last_call: boolean = false) {
  
  logger("Requesting results (last call: " + last_call + ")", "warn");

  let pv_start = 0;
  let pv_end = provCt;
  let filter = provs;

  if (last_call) {

    filter = [];
    filter[99] = "mixed";
    pv_start = 99;
    pv_end = 100;

    reservaD[83] +=1;

  } else {

    vehiculoAry.splice(0, vehiculoAry.length);
    results_returned = 0;
    noResCt = 0;

    disable_search();
    append_results_div();
    redrawDivs(0);

    // Show calling results message. 
    show_loader();
    google_send_search();

  }


  // Call Results: 
  for (let pv = pv_start; pv < pv_end; pv++) {

    // 2018-01 Added ws: pag_atrib, cid: g_cid cycle: - to only save on first call.
    // 2019-04 Break out function to allow for last mixed call:

    let data = {

      tipo_c: "reserva",
      tipo_v: reservaD[7],
      prov: reservaD[15],
      provd: reservaD[16],
      city: reservaD[12],
      cityd: reservaD[13],
      desde: reservaD[1],
      hasta: reservaD[3],
      hdesde: reservaD[2],
      hhasta: reservaD[4],

      cy: pv,                  // used for detecting first call on remote server
      filter: filter[pv],

      ws: reservaD[81],
      rv: reservaD[82],

      pais: reservaD[36],     // French reservas - 2024-07
      paisd: reservaD[37],    // French reservas - 2024-07

      lang: LANG,

      uid: page_id,
      cid: reservaD[85],
      fid: reservaD[96],
      gclid: GCLID,

    };

    ajax_list_results(data)
      .then((json) => {

        let resjson: unknown = json;
        let res = resjson as json_response;

        if (res.status == null
          || res.status.toUpperCase() == "ERROR") {

          noResCt++;
          logger("Error results: " + res.errno + data.filter, "warn");

        } else if (res.status == "") {

          noResCt++;
          logger("No results: " + data.filter, "log");

        } else {

          logger("Results: " + data.filter, "log");

          if (sortResults(res.result)) {
            showResults();
            step1CardListener();
          } else {
            noResCt++;
          }

        }

        results_returned += 1;
        checkZeroes(results_returned, provCt, noResCt);

      });

  }; // for each proveedor.


}



/**
 * Step 2 results
 */
function call_detail(i: number) {

  if (detail_request) {
    logger("Detail request already in progress", "warn");
    return;
  }

  

  logger("Requesting detail: " + i, "log");

  if (typeof vehiculoAry[i]["vid"] == "undefined") {
    logger("Error: vid not set", "error");
    return;
  }

  // !Set reservaD values from chosen vehicle - internal detail does not include on step 2
  reservaD[20] = vehiculoAry[i]["vid"];
  reservaD[21] = vehiculoAry[i]["agid"];
  reservaD[22] = vehiculoAry[i]["ag"];
  reservaD[24] = vehiculoAry[i]["ve"];
  reservaD[26] = vehiculoAry[i]["cu"]*1.00;
  reservaD[27] = (vehiculoAry[i]["cuotaoneway"] ?? 0)*1.00;

  if (typeof vehiculoAry[i]["cominterno"] != "undefined") {
    reservaD[28] = vehiculoAry[i]["cominterno"]
  } else {
    reservaD[28] = 0;
  }

  if (typeof vehiculoAry[i]["qid"] != "undefined") {
    reservaD[80] = vehiculoAry[i]["qid"]
  } else {
    reservaD[80] = "0";
  }

  disable_search();
  redrawDivs(1);

  // Show calling results message. 
  show_loader();
  setHform();
  google_send_detail();

  // Show a loader:  
  let data = {
    tipo_c: "details",
    vid: reservaD[20],
    pid: reservaD[15],
    did: reservaD[16],
    pcid: reservaD[12],
    dcid: reservaD[13],
    aid: reservaD[21],
    sdt: reservaD[9],
    dur: reservaD[5],
    desde: reservaD[1],
    hasta: reservaD[3],
    hdesde: reservaD[2],
    hhasta: reservaD[4],
    tipo_v: reservaD[7],
    rv: reservaD[82],
    ws: reservaD[81],
    cid: reservaD[85],
    fid: reservaD[96],
    pais: reservaD[36],
    paisd: reservaD[37],
    cy: 0,
    lang: LANG,
    gclid: GCLID,
  };
  
  // prevent double click:
  detail_request = true;


  ajax_list_detail(data)
    .then((json) => {

      detail_request = false;

      let resjson: unknown = json;
      let res = resjson as json_response;

      if (res.status == null || res.status == ""
        || res.status.toUpperCase() == "ERROR") {

        logger("Sin resultados (erc:" + res.errno + ")", "error");
        showError(langDict[19]);

        hide_loader();
        enable_search();
        redrawDivs(1);


      } else {

        logger("Result returned: " + data.vid, "log");
        hide_loader();
        enable_search();
        redrawDivs(2);

        showDetail(res.result);
        
        reservaD[88] = res.token;
        
      }

    });

}




function disable_search() {

  // Dim search box
  (<HTMLElement>dQS(".destino_banner_searchbox")).style.opacity = "0.75";

  // Disable search click. 
  (<HTMLInputElement>dId("call_results")).disabled = true;

}


function enable_search() {

  // Dim search box
  (<HTMLElement>dQS(".destino_banner_searchbox")).style.opacity = "1";

  // Disable search click. 
  (<HTMLInputElement>dId("call_results")).disabled = false;

}


// Load results div into whatever page we are on.
function append_results_div() {

  if (!dId("search_results")) {

    logger("Create and append results div");
    const anchor = <HTMLElement>dQS(".destino_top_banner");
    const source = <HTMLElement>dId("rentoauto_results_template");
    const target = document.createElement("section");
    target.id = "search_results";
    target.innerHTML = source.innerHTML;
    source.remove();

    anchor.insertAdjacentElement("afterend", target);

    furauto_div_settings();
  }

}


function furauto_div_settings() {

  (<HTMLElement>dId("pricesChange")).innerHTML = "<div class='update-aviso'>" + langDict[45] + "</div>";

  // Show / Hide Furgo / Turismo filter options:
  filter_filters();

  // Add filter box listener: 
  let filterBtn = <HTMLInputElement>dQS("#filterGrid header");
  filterBtn.addEventListener("click", () => {

    let filter = <HTMLElement>dId("filterGrid");
    filter.classList.toggle("filter-open");

  });


  // Add filter listener:
  let filterBtns = dQSa("#filterGrid div");
  filterBtns.forEach((btn) => {

    let f = <HTMLElement>btn;

    // check if there is a data-filter attribute: 
    btn.addEventListener("click", () => {
      if (f.dataset.filter !== undefined) {
        filterRes(parseInt(f.dataset.filter));
      }
    });

  });


  // Add searchAgain Filter: 
  (<HTMLInputElement>dId("reset_step_1")).addEventListener("click", () => {
    redrawDivs(1);
  });

  // Add save Search listener: 
  (<HTMLInputElement>dId("savesearch_fire")).addEventListener("click", guardarmireserva_build, false);

}

// toggle between cars and vans visible in filter list. 
function filter_filters(){

  logger("filter filters", "log");

  const filter_type = (<HTMLInputElement>dId("f_tipo_vehiculo")).value;
  let filterActive = dQSa(".filter-options div");

  filterActive.forEach((e) => { 
    if ((<HTMLElement>e).dataset.type == filter_type) {
      (<HTMLElement>e).style.display = "flex";
    } else {
      (<HTMLElement>e).style.display = "none";
    }
  });
}

// ! Need to complete working on button toggles.
function filterRes(id: number) {

  logger("Filter results: " + id, "log");

  const all_results = dQSa(".af-car-grid");

  const filter_in = (id: number) => {

    let filtered = dQSa(".gnr-" + id);

    filtered.forEach((e) => {
      (<HTMLElement>e).style.display = "block";
    });

  }

  // Reset:
  if (id == 0) {

    all_results.forEach((e) => {
      (<HTMLElement>e).style.display = "block";
    });

    // Hide "show all" filter if present.
    

  } else {

    all_results.forEach((e) => {
      (<HTMLElement>e).style.display = "none";
    });

    // Hide "show all" filter if present.

    // Turismo Double Filter: 

    // Economicos:
    if (id == 10) {
      filter_in(10);
    }

    // Furgoneta Double Filter:

    // Pequeñas
    if (id == 2) {
      filter_in(3);
      filter_in(4);
    }

    filter_in(id);
  }

}



export { call_results, call_detail, enable_search, filter_filters, filterRes }